import React, { VFC } from 'react'
import { EmailForm } from '../../components/EmailForm'

export const NewTicketUi: VFC = () => {
  return <EmailForm />
}
